import React from 'react';
import { Router } from '../../pages';

import "./Hull.scss";
import { ShopMenu } from '../../pages/Shop/ShopMenu/ShopMenu';
import { ContactButton } from '../../pages/Contact/ContactButton/ContactButton';


export const Hull = () => {
  return (
    <main className="Hull">
      <ShopMenu/>
      <Router className="Router" transition={500} transitionPrefix="page"/>
      <ContactButton/>
    </main>
  )
}

export default Hull;
